// Product Search Data for Enhanced Search
// This file loads product data from a JSON file updated by cron job

window.ProductSearchData = [];
window.ProductSearchDataLoaded = false;

// Function to load product data from JSON file
async function loadProductSearchData() {
  try {
    console.log('🔄 Loading product search data from JSON...');
    // Fetch products from JSON file (updated by cron job)
    const response = await fetch('/assets/products-search.json');
    
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    
    const data = await response.json();
    
    window.ProductSearchData = data.products || [];
    window.ProductSearchDataLoaded = true;
    
    console.log('✅ Product Search Data loaded:', window.ProductSearchData.length, 'products');
    console.log('📅 Last updated:', data.last_updated);
    console.log('🔍 Sample products:', window.ProductSearchData.slice(0, 3).map(p => p.title));
  } catch (error) {
    console.error('❌ Error loading product search data:', error);
    // Fallback to CSV if JSON fails
    await loadCSVSearchData();
  }
}

// Fallback function to load CSV data if live data fails
async function loadCSVSearchData() {
  try {
    const response = await fetch('/assets/searchextra.csv');
    const csvText = await response.text();
    const lines = csvText.split('\n');
    
    // Skip header row and process data
    for (let i = 1; i < lines.length; i++) {
      const line = lines[i].trim();
      if (line) {
        const columns = line.split(',');
        if (columns.length >= 6) {
          window.LiveSearchData.push({
            id: columns[0],
            sku: columns[1],
            handle: columns[2],
            url: columns[3],
            title: columns[4],
            collection: columns[5]
          });
        }
      }
    }
    
    window.LiveSearchDataLoaded = true;
    console.log('CSV Search Data loaded as fallback:', window.LiveSearchData.length, 'products');
  } catch (error) {
    console.error('Error loading CSV search data:', error);
  }
}

// Fuzzy search function for better matching
function fuzzySearch(query, text) {
  if (!query || !text) return false;
  
  const queryLower = query.toLowerCase();
  const textLower = text.toLowerCase();
  
  // Exact match gets highest priority
  if (textLower.includes(queryLower)) return true;
  
  // Check if all query words are present
  const queryWords = queryLower.split(/\s+/);
  return queryWords.every(word => textLower.includes(word));
}

// Search function for product data
function searchProductData(query, limit = 10) {
  if (!query || !window.ProductSearchData || !window.ProductSearchDataLoaded) {
    console.log('🔍 Search conditions not met:', {
      query: !!query,
      hasData: !!window.ProductSearchData,
      dataLoaded: window.ProductSearchDataLoaded,
      dataLength: window.ProductSearchData?.length || 0
    });
    return [];
  }
  
  console.log(`🔍 Searching for "${query}" in ${window.ProductSearchData.length} products...`);
  
  const results = [];
  const queryLower = query.toLowerCase();
  
  // Search in title, vendor, product_type, and tags
  for (const product of window.ProductSearchData) {
    const titleMatch = fuzzySearch(query, product.title);
    const vendorMatch = fuzzySearch(query, product.vendor);
    const typeMatch = fuzzySearch(query, product.product_type);
    
    // Handle tags - could be string or array
    let tagsMatch = false;
    if (product.tags) {
      if (Array.isArray(product.tags)) {
        tagsMatch = product.tags.some(tag => fuzzySearch(query, tag));
      } else if (typeof product.tags === 'string') {
        tagsMatch = fuzzySearch(query, product.tags);
      }
    }
    
    if (titleMatch || vendorMatch || typeMatch || tagsMatch) {
      results.push({
        ...product,
        matchType: titleMatch ? 'title' : vendorMatch ? 'vendor' : typeMatch ? 'type' : 'tags',
        relevanceScore: calculateProductRelevanceScore(query, product, titleMatch, vendorMatch, typeMatch, tagsMatch)
      });
    }
  }
  
  console.log(`🔍 Found ${results.length} matches for "${query}"`);
  
  // Sort by relevance and return limited results
  const finalResults = results
    .sort((a, b) => b.relevanceScore - a.relevanceScore)
    .slice(0, limit);
    
  console.log(`🔍 Returning ${finalResults.length} results for "${query}"`);
  return finalResults;
}

// Calculate relevance score for product data
function calculateProductRelevanceScore(query, product, titleMatch, vendorMatch, typeMatch, tagsMatch) {
  let score = 0;
  const queryLower = query.toLowerCase();
  const titleLower = product.title.toLowerCase();
  
  // Title matches get highest score
  if (titleMatch) {
    score += 100;
    // Bonus for exact title match
    if (titleLower === queryLower) score += 50;
    // Bonus for title starting with query
    if (titleLower.startsWith(queryLower)) score += 25;
  }
  
  // Vendor matches get medium score
  if (vendorMatch) score += 60;
  
  // Product type matches get medium score
  if (typeMatch) score += 50;
  
  // Tags matches get lower score
  if (tagsMatch) score += 30;
  
  // Bonus for shorter titles (more specific)
  score += Math.max(0, 50 - product.title.length);
  
  return score;
}

// Legacy functions for backward compatibility
function calculateLiveRelevanceScore(query, product, titleMatch, vendorMatch, typeMatch, tagsMatch) {
  return calculateProductRelevanceScore(query, product, titleMatch, vendorMatch, typeMatch, tagsMatch);
}

function calculateRelevanceScore(query, product, titleMatch, collectionMatch, skuMatch) {
  return calculateProductRelevanceScore(query, product, titleMatch, false, false, false);
}

// Initialize product data when DOM is loaded
document.addEventListener('DOMContentLoaded', loadProductSearchData);
